import { get } from 'lodash';

import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './';
import * as services from '../services/getTranslations';

export const GET_TRANSLATIONS = createAsyncAction(createAction('GET_TRANSLATIONS'));

export const getTranslations = (keys) => (dispatch, getState) => {
  const locale = getCurrentLanguage().toUpperCase();
  const serviceId = get(getState(), 'appointmentInfo.currentAppointment.service.serviceId');

  dispatch({ type: GET_TRANSLATIONS.pending });

  const apiCallParams = {
    query: services.GET_TRANSLATIONS,
    fetchPolicy: 'no-cache',
    variables: {
      keys,
      locale,
      serviceId,
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { getTranslations } }) => {
      dispatch({
        type: GET_TRANSLATIONS.success,
        payload: getTranslations,
      });

      return getTranslations;
    })
    .catch((err) => dispatch(errorAction(GET_TRANSLATIONS.failure, err)));
};
